/**
 * SectionSummaryBar — compact today-at-a-glance stat row shown at the top of
 * section pages. Stats are computed by the parent section component.
 *
 * Props:
 *   stats  {Array<{ value: string, label: string, accent?: 'warning'|'danger' }>}
 */
const SectionSummaryBar = ({ stats }) => {
  if (!stats?.length) return null;
  return (
    <div className="section-summary-bar">
      {stats.map((stat, i) => (
        <div
          key={i}
          className={`section-summary-stat${stat.accent ? ` section-summary-stat--${stat.accent}` : ''}`}
        >
          <div className="section-summary-value">{stat.value}</div>
          <div className="section-summary-label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default SectionSummaryBar;
